import equal from "fast-deep-equal/es6";
import { produce } from "immer";
import { combineReducers } from "redux";
import { createReducer } from "typesafe-actions";
import { getEntityActions } from "./actions.js";
import { isObject } from "./utils.js";
class EntityReducerCreator {
  _entityActions;
  constructor() {
    this._entityActions = getEntityActions();
  }
  createReducer(entityTypes) {
    const entitiesReducer = {};
    entityTypes.forEach((entityType) => entitiesReducer[entityType] = this.createEntityItemsReducer(entityType));
    const referencesReducer = this.createReferencesReducer();
    return combineReducers({
      entities: combineReducers(entitiesReducer),
      references: referencesReducer
    });
  }
  createEntityItemsReducer(entityType) {
    return createReducer({}).handleAction(this._entityActions.save, (state, action) => {
      let newState = state;
      if (entityType === action.payload.type && action.payload.items && Object.keys(action.payload.items).length !== 0) {
        newState = produce(state, (draftState) => {
          this.updateItemField(draftState, action.payload.items);
        });
      }
      return newState;
    }).handleAction(this._entityActions.updateItem, (state, action) => {
      let newState = state;
      if (entityType === action.payload.type && action.payload.id && action.payload.updatedItem && state[action.payload.id]) {
        newState = produce(state, (draftState) => {
          this.updateItemField(draftState[action.payload.id], action.payload.updatedItem);
        });
      }
      return newState;
    }).handleAction(this._entityActions.clean, (state, action) => {
      let newState = state;
      const { ids, type } = action.payload;
      if (entityType === type) {
        newState = produce(state, (draftState) => {
          ids.forEach((id) => {
            delete draftState[id];
          });
        });
      }
      return newState;
    });
  }
  createReferencesReducer() {
    return createReducer({}).handleAction(this._entityActions.increaseReferenceCounter, (state, action) => {
      let newState = state;
      newState = produce(state, (draftState) => {
        const { references } = action.payload;
        if (references?.length > 0) {
          references.forEach((ref) => {
            let count = draftState[ref];
            count = count > 0 ? count + 1 : 1;
            draftState[ref] = count;
          });
        }
        return draftState;
      });
      return newState;
    }).handleAction(this._entityActions.decreaseReferenceCounter, (state, action) => {
      let newState = state;
      newState = produce(state, (draftState) => {
        const { references } = action.payload;
        if (references?.length > 0) {
          references.forEach((ref) => {
            let count = draftState[ref];
            count = count > 0 ? count - 1 : 0;
            draftState[ref] = count;
          });
        }
        return draftState;
      });
      return newState;
    }).handleAction(this._entityActions.cleanReferenceCounter, (state, action) => {
      let newState = state;
      newState = produce(state, (draftState) => {
        const { references } = action.payload;
        if (references?.length > 0) {
          references.forEach((ref) => {
            delete draftState[ref];
          });
        }
        return draftState;
      });
      return newState;
    });
  }
  updateItemField(currentItem, newItem) {
    Object.entries(newItem).forEach((value) => {
      const [key, newValue] = value;
      const isFieldExists = Object.prototype.hasOwnProperty.call(currentItem, key);
      const isFieldEmpty = !isFieldExists || currentItem[key] === null;
      const isFieldChanged = isFieldExists && !equal(newValue, currentItem[key]);
      if (isFieldEmpty || isFieldChanged && !isObject(newValue)) {
        currentItem[key] = newValue;
      } else if (isFieldChanged && isObject(newValue)) {
        this.updateItemField(currentItem[key], newValue);
      }
    });
  }
}
export {
  EntityReducerCreator
};
//# sourceMappingURL=reducers.js.map
